import { render } from "./BarcodeSave.vue?vue&type=template&id=26eeb0c1"
import script from "./BarcodeSave.vue?vue&type=script&lang=js"
export * from "./BarcodeSave.vue?vue&type=script&lang=js"
script.render = render

export default script